import { enviarFormulario, obterJson } from './v2/api';
import { avisarErro } from './v2/aviso';
import { ocupar } from './v2/botao';
import { config, formatar, textos, url } from './v2/config';
import { iniciarMedicaoPagina } from './v2/medicao';
import { obterGeo, obterUsuario } from './v2/usuario';

// Contato v2 (protótipo v39): um passo por vez — assunto, categoria (só com mais de uma), orientação (só quando há texto)
// e o formulário de hoje (contato.js do v1: os mesmos campos, nomes, máscara, validação e o CriarTicketContato).
// Cada passo entra no histórico, para o Voltar do celular voltar um passo.
const $ = id => document.getElementById(id);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const semAnimacao = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const T = textos($('ctPagina'));
const ASSUNTOS = (() => {
    try {
        return JSON.parse($('ctDados')?.textContent || '[]');
    } catch {
        return [];
    }
})();
const cartao = $('ctCard');
const form = $('ctForm');
const LIMITE_ANEXOS = 10 * 1024 * 1024;
const INICIO = { a: null, s: null, abrir: false, ok: false };
// A regra 'email' do JustValidate (contato.js do v1): domínio só com letras, números e hífen, e terminação de 2 letras ou mais.
const EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

let _estado = { ...INICIO };
let _anexos = [];
let _validado = false;
let _enviando = false;
let _telefone = null;
let _mascaraCpf = null;
let _formularioPronto = null;

// ---------- passos ----------
// Com uma categoria só, ela vem escolhida (como no v1, que escondia a pergunta "Categoria").
function _sub(e = _estado) {
    const a = ASSUNTOS[e.a];
    if (!a) {
        return null;
    }
    return a.subs.length === 1 ? 0 : e.s;
}

function _passo(e = _estado) {
    if (e.ok) {
        return 'ok';
    }
    const a = ASSUNTOS[e.a];
    if (!a) {
        return 'assunto';
    }
    const s = _sub(e);
    if (s === null || s === undefined || !a.subs[s]) {
        return 'categoria';
    }
    return a.subs[s].txt && !e.abrir ? 'guia' : 'form';
}

function _mostrar(focar) {
    const passo = _passo();
    const a = ASSUNTOS[_estado.a];
    const s = _sub();
    $$('.ct__passo', cartao).forEach(p => {
        p.hidden = !(p.dataset.passo === passo && (passo !== 'categoria' || +p.dataset.assunto === _estado.a));
    });

    if (passo === 'guia') {
        $('ctT-guia').textContent = a.subs.length > 1 ? a.subs[s].t : a.t;
        // A orientação fica num <template> no HTML e só entra no cartão aqui.
        const modelo = $(`ctGuia-${_estado.a}-${s}`);
        $('ctGuia').replaceChildren(modelo ? modelo.content.cloneNode(true) : '');
        $$('#ctGuia a[href^="http"]').forEach(link => { link.target = '_blank'; link.rel = 'noopener'; });
        // Quem já entrou não precisa do cadastro nem do "Entrar" (a orientação é a mesma para todos no HTML).
        obterUsuario().then(u => { if (u.logado) { $$('#ctGuia [data-visitante]').forEach(el => el.remove()); } });
        // "Procuro vaga de emprego" e "Enviar Currículo" não abrem chamado (regra do v1): só o "Voltar".
        cartao.querySelector('[data-ct-abrir]').hidden = !a.subs[s].abre;
    }
    if (passo === 'form') {
        $('ctEscolha').textContent = a.subs.length > 1 ? `${a.t} › ${a.subs[s].t}` : a.t;
        $('ctAssunto').value = a.id;
        $('ctSub').value = a.subs[s].id;
        _prepararFormulario();
        _aoMostrarFormulario();
    }

    const titulo = cartao.querySelector('.ct__passo:not([hidden]) h2');
    cartao.setAttribute('aria-labelledby', titulo.id);
    if (focar) {
        // Passo novo: se o alto do cartão ficou acima da tela, ele volta à vista.
        const topo = cartao.getBoundingClientRect().top - (document.querySelector('.site-h')?.getBoundingClientRect().bottom || 0) - 12;
        if (topo < 0) {
            window.scrollBy({ top: topo, behavior: semAnimacao() ? 'auto' : 'smooth' });
        }
        titulo.focus({ preventScroll: true });
    }
}

function _ir(mudanca) {
    _estado = { ..._estado, ...mudanca };
    const n = (history.state?.ctN || 0) + 1;
    history.pushState({ ...(history.state || {}), ctPasso: _estado, ctN: n }, '');
    _mostrar(true);
}

// Voltar e Trocar usam o histórico (o Voltar do celular faz o mesmo); sem passo anterior nele, calcula o anterior.
function _voltar() {
    if (history.state?.ctN > 0) {
        history.back();
        return;
    }
    const a = ASSUNTOS[_estado.a];
    const passo = _passo();
    if (passo === 'form' && a.subs[_sub()].txt) {
        _estado = { ..._estado, abrir: false };
    } else if ((passo === 'form' || passo === 'guia') && a.subs.length > 1) {
        _estado = { ..._estado, s: null, abrir: false };
    } else {
        _estado = { ...INICIO };
    }
    history.replaceState({ ...(history.state || {}), ctPasso: _estado, ctN: 0 }, '');
    _mostrar(true);
}

function _trocar() {
    const n = history.state?.ctN || 0;
    if (n > 0) {
        history.go(-n);
        return;
    }
    _estado = { ...INICIO };
    history.replaceState({ ...(history.state || {}), ctPasso: _estado, ctN: 0 }, '');
    _mostrar(true);
}

window.addEventListener('popstate', e => {
    const novo = e.state?.ctPasso || INICIO;
    // O menu do topo também usa o histórico: fechar o menu não pode mexer no passo.
    if (JSON.stringify(novo) === JSON.stringify(_estado)) {
        return;
    }
    _estado = { ...INICIO, ...novo };
    _mostrar(true);
});

// ---------- formulário (as regras do contato.js do v1) ----------
function _dispositivo() {
    if (/Tablet|iPad/i.test(navigator.userAgent)) {
        return 'Tablet';
    }
    if (/Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i.test(navigator.userAgent)) {
        return 'Mobile';
    }
    return 'Desktop';
}

// Quem entrou: o nome no "Olá" e os campos do cadastro (sem cache: é dado pessoal).
const _pessoa = obterUsuario()
    .then(u => (u.logado ? obterJson(url('/PaginasEstaticas/GetDetalhesPessoa'), { semCache: true }) : null))
    .then(r => (r?.logado && r.pessoa ? r.pessoa : null))
    .catch(() => null);

_pessoa.then(p => {
    if (p?.Nome) {
        $('ctOla').textContent = p.Nome;
    }
});

function _cpfPorPais() {
    const brasil = $('ctPais').value === 'BR';
    $('ctCpfCampo').hidden = !brasil;
    if (!brasil) {
        _mostrarErro('cpf', '');
    }
}

// Quem entrou: os campos do cadastro (na 1ª vez que o formulário aparece e de novo depois de um envio).
function _preencherPessoa(pessoa) {
    if (pessoa) {
        $('ctPessoa').value = pessoa.PessoaID || '';
        $('ctNome').value = pessoa.Nome || '';
        $('ctEmail').value = pessoa.Email || '';
        $('ctPais').value = pessoa.PaisID || '';
        if (pessoa.PaisID === 'BR' && pessoa.Cpf && _mascaraCpf) {
            _mascaraCpf.value = pessoa.Cpf;
        }
        _telefone?.setNumber(pessoa.CelularPaisCode ?? pessoa.TelefonePaisCode ?? '');
        $('ctTel').value = pessoa.Celular ?? pessoa.Telefone ?? '';
    }
    _cpfPorPais();
}

function _prepararFormulario() {
    // intl-tel-input e IMask só baixam quando o formulário aparece.
    _formularioPronto ??= Promise.all([
        import(/* webpackChunkName: "intl-tel-input" */ 'intl-tel-input'),
        import(/* webpackChunkName: "imask" */ 'imask'),
        _pessoa
    ]).then(([{ default: intlTelInput }, { default: IMask }, pessoa]) => {
        const telefone = $('ctTel');
        // País da conexão fora da lista da biblioteca derrubaria a criação do campo: começa no Brasil.
        const daConexao = (obterGeo()?.pais || '').toLowerCase();
        const conhecido = window.intlTelInputGlobals?.getCountryData().some(c => c.iso2 === daConexao);
        _telefone = intlTelInput(telefone, {
            initialCountry: conhecido ? daConexao : 'br',
            preferredCountries: ['br', 'cl', 'ar', 'es', 'pt', 'us', 'fr'],
            autoPlaceholder: 'aggressive',
            utilsScript: '/assetsV2/lib/intl-tel-util/utils.js'
        });
        _mascaraCpf = IMask($('ctCpf'), { mask: '000.000.000-00' });
        _preencherPessoa(pessoa);
    }).catch(() => {
        _formularioPronto = null;
    });
    return _formularioPronto;
}

function _erroDe(campo) {
    const valor = (campo === 'cpf' ? $('ctCpf').value : form.querySelector(`[data-campo="${campo}"]`).value).trim();
    switch (campo) {
        case 'nome':
            return valor ? '' : T.nome;
        case 'email':
            return !valor ? T.emailObrigatorio : EMAIL.test(valor) ? '' : T.email;
        case 'telefone':
            return valor ? '' : T.telefone;
        case 'pais':
            return valor ? '' : T.pais;
        case 'cpf':
            if ($('ctPais').value !== 'BR') {
                return '';
            }
            return !valor ? T.cpfObrigatorio : valor.replace(/\D/g, '').length === 11 ? '' : T.cpf;
        case 'mensagem':
            return valor ? '' : T.mensagem;
        default:
            return '';
    }
}

function _mostrarErro(campo, erro) {
    const aviso = $(`ctE-${campo}`);
    const entrada = form.querySelector(`[data-campo="${campo}"]`);
    entrada?.closest('.ct__f')?.classList.toggle('is-err', !!erro);
    if (erro) {
        entrada?.setAttribute('aria-invalid', 'true');
    } else {
        entrada?.removeAttribute('aria-invalid');
    }
    if (aviso) {
        aviso.querySelector('span').textContent = erro;
        aviso.hidden = !erro;
    }
}

function _validar() {
    _validado = true;
    const campos = ['nome', 'email', 'telefone', 'pais', 'cpf', 'mensagem'];
    let primeiro = null;
    campos.forEach(c => {
        const erro = _erroDe(c);
        _mostrarErro(c, erro);
        if (erro && !primeiro) {
            primeiro = c;
        }
    });
    if (primeiro) {
        form.querySelector(`[data-campo="${primeiro}"]`)?.focus();
    }
    return !primeiro;
}

function _desenharAnexos() {
    const lista = $('ctAnexos');
    lista.replaceChildren(..._anexos.map((f, i) => {
        const li = document.createElement('li');
        const nome = document.createElement('span');
        nome.textContent = f.name;
        const tamanho = document.createElement('small');
        tamanho.textContent = f.size >= 1048576 ? `${(f.size / 1048576).toFixed(1).replace('.', ',')} MB` : `${Math.max(1, Math.round(f.size / 1024))} KB`;
        const remover = document.createElement('button');
        remover.type = 'button';
        remover.className = 'ct__anx-x';
        remover.dataset.remover = i;
        remover.setAttribute('aria-label', formatar(T.remover, f.name));
        remover.innerHTML = '<svg class="ico" aria-hidden="true"><use href="#i-x-lg"></use></svg>';
        li.append(nome, tamanho, remover);
        return li;
    }));
    lista.hidden = !_anexos.length;
}

async function _enviar() {
    if (_enviando || !_validar()) {
        return;
    }
    // Mesmo limite do v1, somando todos os arquivos (o servidor aceita até 20 MB).
    if (_anexos.reduce((t, f) => t + f.size, 0) > LIMITE_ANEXOS) {
        avisarErro(T.arquivos);
        return;
    }
    _enviando = true;
    const botao = $('ctEnviar');
    ocupar(botao);
    $('ctPlataforma').value = _dispositivo();
    $('ctDdi').value = _telefone?.getSelectedCountryData()?.dialCode || '';
    const dados = new FormData(form);
    _anexos.forEach(f => dados.append('anexos', f, f.name));
    try {
        const r = await enviarFormulario(form.action, dados);
        if (r?.sucesso) {
            form.reset();
            _mascaraCpf?.updateValue();
            // O reset volta o país para o Brasil: o CPF (e os dados de quem entrou) acompanham.
            _pessoa.then(_preencherPessoa);
            _anexos = [];
            _desenharAnexos();
            _validado = false;
            Object.assign(_sug, { ultimo: '', interacao: null, resolvido: false, mostrados: [] });
            _esconderSugestoes();
            $('ctSugFim').hidden = true;
            _estado = { ..._estado, ok: true };
            history.replaceState({ ...(history.state || {}), ctPasso: _estado }, '');
            _mostrar(true);
        } else {
            avisarErro(r?.mensagem || T.erro);
        }
    } catch {
        avisarErro(T.erro);
    } finally {
        _enviando = false;
        ocupar(botao, false);
    }
}

// ---------- eventos ----------
cartao.addEventListener('click', e => {
    const t = e.target;
    const assunto = t.closest('[data-ct-assunto]');
    if (assunto) {
        _ir({ a: +assunto.dataset.ctAssunto, s: null, abrir: false });
        return;
    }
    const sub = t.closest('[data-ct-sub]');
    if (sub) {
        _ir({ s: +sub.dataset.ctSub, abrir: false });
        return;
    }
    if (t.closest('[data-ct-abrir]')) {
        _ir({ abrir: true });
        return;
    }
    if (t.closest('[data-ct-voltar]')) {
        _voltar();
        return;
    }
    if (t.closest('[data-ct-trocar]')) {
        _trocar();
        return;
    }
    const remover = t.closest('[data-remover]');
    if (remover) {
        _anexos.splice(+remover.dataset.remover, 1);
        _desenharAnexos();
        $('ctArq').focus();
    }
});

form.addEventListener('submit', e => {
    e.preventDefault();
    _enviar();
});

// Depois da 1ª tentativa de envio, o erro de cada campo some (ou troca) enquanto a pessoa corrige (como o JustValidate).
form.addEventListener('input', e => {
    const campo = e.target.dataset?.campo;
    if (_validado && campo) {
        _mostrarErro(campo, _erroDe(campo));
    }
});
form.addEventListener('change', e => {
    if (e.target.id === 'ctPais') {
        _cpfPorPais();
    }
    if (e.target.id === 'ctArq') {
        _anexos.push(...e.target.files);
        e.target.value = '';
        _desenharAnexos();
    }
    const campo = e.target.dataset?.campo;
    if (_validado && campo) {
        _mostrarErro(campo, _erroDe(campo));
    }
});

// ---------- Central de Ajuda (F5a): "Estes artigos podem resolver" e a origem do chamado ----------
// A origem (#origem= do "Abrir chamado" da central: no fragmento, para não criar uma cópia desta página na borda a cada link) vai num
// campo escondido e fica só no nosso banco, depois do chamado criado.
const ORIGEM = /^(?:(?:artigo|interacao)-[1-9]\d{0,8}|ajuda)$/;
const _origem = new URLSearchParams(location.hash.slice(1)).get('origem');
if (_origem && ORIGEM.test(_origem)) {
    $('ctOrigem').value = _origem;
}

// O quadro: até 3 artigos pela busca da central (sem IA gerando texto), com 600 ms de atraso e a partir de 15 caracteres.
const SUGESTAO_MINIMO = 15;
const SUGESTAO_ATRASO = 600;
const SUGESTAO_MAXIMO = 500;
const _sug = { espera: null, ultimo: '', pedido: 0, mostrados: [], interacao: null, resolvido: false };

// O Contato fica na borda e não traz o token antiforgery: pede um na 1ª vez (o 400 de token velho renova pelo mesmo endereço).
async function _garantirToken() {
    const c = config();
    c.afNovo = url('/ajuda/token');
    if (!c.af) {
        const r = await obterJson(c.afNovo, { semCache: true }).catch(() => null);
        if (r?.af) {
            c.af = r.af;
        }
    }
}

const _descricao = () => $('ctMsg').value.replace(/\s+/g, ' ').trim().slice(0, SUGESTAO_MAXIMO);

function _desenharSugestoes(artigos) {
    _sug.mostrados = artigos.map(a => a.id);
    $('ctSugLista').replaceChildren(...artigos.map(a => {
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'ct-sug__a';
        link.href = a.url;
        link.target = '_blank';
        link.rel = 'noopener';
        link.dataset.id = a.id;
        if (a.lang) {
            link.lang = a.lang;
        }
        // Abre em outra aba: o formulário que a pessoa está escrevendo fica.
        link.innerHTML = '<svg class="ico" aria-hidden="true"><use href="#i-chevron-right"></use></svg>';
        const titulo = document.createElement('span');
        titulo.textContent = a.titulo;
        const aba = document.createElement('span');
        aba.className = 'sr';
        aba.textContent = T.novaAba || '';
        link.append(titulo, aba);
        li.append(link);
        return li;
    }));
    $('ctSug').hidden = !artigos.length;
    // O quadro nasce escondido e o leitor de tela não anuncia o que aparece nele: o aviso vai numa região que está sempre na página.
    // Com a quantidade: a lista nova com outro número é anunciada de novo.
    $('ctSugStatus').textContent = artigos.length ? `${T.sugestoes || ''} (${artigos.length})` : '';
}

function _esconderSugestoes() {
    $('ctSug').hidden = true;
    $('ctSugStatus').textContent = '';
}

async function _sugerir() {
    const texto = _descricao();
    // No hotsite, o Ajuda/Sugestoes devolve só os artigos dos hotsites (o Contato v2 só existe no www e nos genéricos).
    if (_sug.resolvido) {
        return;
    }
    if (texto.length < SUGESTAO_MINIMO) {
        // O pedido que ainda está a caminho não redesenha o quadro.
        _sug.pedido++;
        _sug.ultimo = '';
        _esconderSugestoes();
        return;
    }
    if (texto.toLowerCase() === _sug.ultimo) {
        return;
    }
    const pedido = ++_sug.pedido;
    await _garantirToken();
    const dados = new FormData();
    dados.append('texto', texto);
    const r = await enviarFormulario(url('/ajuda/sugestoes'), dados, { silencioso: true, tempo: 10000 }).catch(() => null);
    // A pessoa continuou escrevendo (vale o pedido mais novo) ou já disse que resolveu. Falha deixa o quadro como estava e deixa o mesmo
    // texto ser tentado de novo.
    if (pedido !== _sug.pedido || _sug.resolvido || !r) {
        return;
    }
    _sug.ultimo = texto.toLowerCase();
    _desenharSugestoes(r.artigos || []);
}

// O clique numa sugestão e o "Resolveu?" (AjudaInteracao tipo 3): a 1ª ação cria a interação, as outras atualizam a mesma. Em fila: o
// "Resolveu?" logo depois de um clique espera a 1ª resposta (com o ID), senão gravaria duas linhas.
let _filaSugestao = Promise.resolve();
function _registrarSugestao(valores) {
    _filaSugestao = _filaSugestao.then(async () => {
        await _garantirToken();
        const dados = new FormData();
        if (_sug.interacao) {
            dados.append('interacao', _sug.interacao);
        }
        dados.append('texto', _descricao());
        dados.append('artigos', _sug.mostrados.join(','));
        Object.entries(valores).forEach(([chave, valor]) => dados.append(chave, String(valor)));
        const r = await enviarFormulario(url('/ajuda/sugestao'), dados, { silencioso: true }).catch(() => null);
        if (r?.interacao) {
            _sug.interacao = r.interacao;
        }
    }).catch(() => { });
    return _filaSugestao;
}

// A pergunta e o assunto da assistente (sessionStorage, nunca a URL): lidos e apagados já no carregamento (senão esperariam na aba até
// outro chamado) e só com a mesma origem do link.
let _perguntaDaAjuda = '';
let _assuntoDaAjuda = null;
try {
    const bruto = sessionStorage.getItem('ajuda:pergunta');
    sessionStorage.removeItem('ajuda:pergunta');
    const salvo = JSON.parse(bruto || 'null');
    if (salvo?.origem && salvo.origem === _origem && typeof salvo.pergunta === 'string') {
        _perguntaDaAjuda = salvo.pergunta.slice(0, 2000);
        _assuntoDaAjuda = typeof salvo.chamado === 'string' ? salvo.chamado : null;
    }
} catch {
    // Sem o sessionStorage (ou com outro conteúdo na chave), a descrição fica vazia.
}

// Com o assunto da assistente, direto ao formulário (a orientação repetiria a central). Subcategoria que não abre chamado, ou que não
// existe mais, fica no passo do assunto.
function _passoDaAjuda() {
    for (let a = 0; a < ASSUNTOS.length; a++) {
        const s = ASSUNTOS[a].subs.findIndex(sub => sub.id === _assuntoDaAjuda);
        if (s >= 0) {
            return ASSUNTOS[a].subs[s].abre ? { ...INICIO, a, s, abrir: true } : null;
        }
    }
    return null;
}

function _aoMostrarFormulario() {
    if (_perguntaDaAjuda && !$('ctMsg').value.trim()) {
        $('ctMsg').value = _perguntaDaAjuda;
    }
    _perguntaDaAjuda = '';
    if (_descricao().length >= SUGESTAO_MINIMO) {
        _sugerir();
    }
}

$('ctMsg').addEventListener('input', () => {
    clearTimeout(_sug.espera);
    _sug.espera = setTimeout(_sugerir, SUGESTAO_ATRASO);
});

const _aoAbrirSugestao = e => {
    const link = e.target.closest('a[data-id]');
    if (link && (e.type === 'click' || e.button === 1)) {
        _registrarSugestao({ artigo: link.dataset.id });
    }
};
$('ctSugLista').addEventListener('click', _aoAbrirSugestao);
$('ctSugLista').addEventListener('auxclick', _aoAbrirSugestao);

$('ctSug').querySelector('[data-ct-resolveu]').addEventListener('click', () => {
    _sug.resolvido = true;
    _registrarSugestao({ resolveu: true });
    _esconderSugestoes();
    $('ctSugFim').hidden = false;
    $('ctSugFim').focus();
});

// Voltando a esta página (F5, voltar do navegador), o passo que estava na tela continua.
// Depois do envio, recarregar volta ao começo (como no v1).
const _daAjuda = _assuntoDaAjuda ? _passoDaAjuda() : null;
if (history.state?.ctPasso && !history.state.ctPasso.ok) {
    _estado = { ...INICIO, ...history.state.ctPasso };
    _mostrar(false);
} else if (_daAjuda) {
    _estado = _daAjuda;
    history.replaceState({ ...(history.state || {}), ctPasso: _estado, ctN: 0 }, '');
    _mostrar(false);
} else {
    history.replaceState({ ...(history.state || {}), ctPasso: _estado, ctN: 0 }, '');
}

iniciarMedicaoPagina('contato');
